var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.options.length
    ? _c(
        _setup.FormControlTypeSelect,
        _vm._g(
          _vm._b(
            { attrs: { options: _setup.options } },
            "FormControlTypeSelect",
            _vm.$props,
            false
          ),
          _vm.$listeners
        )
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }